import { Component, Input, EventEmitter, Output, Inject } from '@angular/core';

@Component({
    selector: 'app-orderer',
    template: `
        <div class="d-flex flex-row gap-1" style="min-width: 125px">
            <input *ngIf="isWeeklyTopOrder" type="number" [(ngModel)]="data.weeklyTopOrder" class="form-control" />
            <input *ngIf="isCarouselOrder" type="number" [(ngModel)]="data.carouselOrder" class="form-control" />
        </div>
    `,
})
export class OrdererComponent {
    @Input()
    data: any = {};

    @Input()
    isWeeklyTopOrder: boolean = false;

    @Input()
    isCarouselOrder: boolean = false;

    @Output() emitter: EventEmitter<boolean> = new EventEmitter(false);
}
